export const Initials = ({ name, size = 40, testid }) => {
  const initials = (name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("") || "?";
  return (
    <div
      data-testid={testid}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      className="shrink-0 flex items-center justify-center bg-primary/10 text-primary font-display font-extrabold border border-primary/25 select-none"
    >
      {initials}
    </div>
  );
};
